import {
  createFormHookContexts,
  createFormHook,
} from "@tanstack/react-form";

// Create form contexts
const { fieldContext, formContext } =
  createFormHookContexts();

// Create custom form hook
export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
});
